import Vue from 'vue'
import nsukApplication from "./pages/nsuk/Application.vue";
import store from './store'
import nsukRouter from './routes'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import axios from 'axios';
import NotificationPlugin from '../plugins/notify';
//import 'vue-toast-notification/dist/theme-default.css';
import "vue-toastification/dist/index.css";
import vuetifyNsuk from "@/plugins/vuetify";
import urlUtil from "@/utils/urlUtil";


axios.defaults.baseURL = urlUtil.getBaseUrl();


Vue.config.productionTip = false
Vue.use(VueToast);
Vue.use(NotificationPlugin)
new Vue({
    store,
    vuetify: vuetifyNsuk,
    router: nsukRouter,
    render: h => h(nsukApplication)
}).$mount('#app')
